import { useEffect, useState } from "react";
import Box from "elements/Box";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { useSnackbar } from "notistack";
import ReportViewer from "../../Reports/ReportViewer";
import { ApiRequest } from "GlobalFunctions";
import AutocompleteField from "elements/AutocompleteField";

export default function AdminReports(props: any) {
  const { setLoading } = props;

  const [loadingPopup, setLoadingPopup] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setLoading(false);
  }, []);

  const defaultValues: any = {
    company_id: null,
  };

  const [exportType, setExportType] = useState("");
  const [formValues, setFormValues] = useState({ ...defaultValues });
  const [reportName, setReportName] = useState("");
  const [subtitle, setSubtitle] = useState("");

  const [data, setData] = useState([]);
  const [openViewer, setOpenViewer] = useState(false);

  const getReport = async (download = "") => {
    setLoading(true);
    setLoadingPopup(true);

    // Validate company selection
    if (!formValues.company_id) {
      enqueueSnackbar("Debes seleccionar una empresa", { variant: "error" });
      setLoading(false);
      setLoadingPopup(false);
      return;
    }

    await ApiRequest({
      url: "/reports/getReport",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        ...formValues,
        exportType,
        module: "admin",
        download,
      },
      setResponse: (response: any) => {
        if (response.status === "success") {
          setData(response.data);
          setSubtitle(response.subtitle || "");
          setOpenViewer(true);

          if (download === "pdf") {
            window.open(response.pdfUrl, "_blank");
          }
          if (download === "excel") {
            window.open(response.fileUrl, "_blank");
          }
        } else {
          enqueueSnackbar(response.message, { variant: "error" });
        }
        setLoading(false);
        setLoadingPopup(false);
      },
    });
  };

  return (
    <>
      <div id="SupplierList" className="ModuleContainer">
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Reportes Admin</h2>
              <span className="h2_subtitle">Selecciona el tipo de exportación</span>
            </div>
          </div>

          <Box id="SupplierListIn" className="box100">
            <FormControl fullWidth>
              <InputLabel id="admin-report-select-label">Reporte</InputLabel>
              <Select
                labelId="admin-report-select-label"
                id="admin-report-select"
                value={exportType}
                label="Reporte"
                onChange={(e: any) => {
                  setExportType(e.target.value);
                  setFormValues({ ...defaultValues });
                  setReportName(e.target.value);
                }}
              >
                <MenuItem value={"clients_by_company"}>Clientes por empresa</MenuItem>
                <MenuItem value={"products_by_company"}>Productos por empresa</MenuItem>
              </Select>
            </FormControl>

            {/* Company filter */}
            {(exportType === "clients_by_company" || exportType === "products_by_company") && (
              <AutocompleteField
                label="Empresa"
                endpoint="/companies/list"
                endpoint_params={{ full_list: true }}
                value={formValues.company_id}
                onChange={(data: any) => {
                  setFormValues({ ...formValues, company_id: data?.value || null });
                }}
              />
            )}

            {exportType && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  getReport();
                }}
                startIcon={<CloudDownloadOutlinedIcon />}
              >
                Ver
              </Button>
            )}
          </Box>
        </div>
      </div>

      <ReportViewer
        open={openViewer}
        setOpen={setOpenViewer}
        data={data}
        loading={loadingPopup}
        setLoading={setLoading}
        reportName={reportName}
        getReport={getReport}
        subtitle={subtitle}
      />
    </>
  );
}
